import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppTable } from '@/UI/AppTable/AppTable';
import { color } from '@/colors';
import { I18N_KEYS } from '@/language/keys';

const headerLabelSx = {
  fontFamily: '"DM Mono", ui-monospace, monospace',
  letterSpacing: '0.02em',
} as const;

export const ApiKeysTableHeader = () => {
  const { t } = useTranslation();

  return (
    <AppTable.Tr>
      <AppTable.Th sx={{ pl: 1.5 }}>
        <Typography variant="body-xs-rg" color={color.White64_T} sx={{ ...headerLabelSx, m: 0 }}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_PROVIDER)}
        </Typography>
      </AppTable.Th>
      <AppTable.Th>
        <Typography variant="body-xs-rg" color={color.White64_T} sx={{ ...headerLabelSx, m: 0 }}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_CREDENTIALS)}
        </Typography>
      </AppTable.Th>
      <AppTable.Th>
        <Typography variant="body-xs-rg" color={color.White64_T} sx={{ ...headerLabelSx, m: 0 }}>
          {t(I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_STATUS)}
        </Typography>
      </AppTable.Th>
      <AppTable.Th align="right" ariaHidden sx={{ width: 132 }} />
    </AppTable.Tr>
  );
};
